import React from 'react';
import { SubHeading } from './subHeading';
import { Link } from 'react-router-dom';
import { AddButton } from './addButton';
import Banners from '../data/data.json';
import { SimpleImg } from 'react-simple-img';



export const NewCollections = props => {
  const allProducts = Banners.products.filter(
    item => item.categ !== 'promo' && item.categ !== 'cat'
  );
  return (
    <>
      <SubHeading title={props.cat} />
      <div className="side-by-side">
        {allProducts.map(collection => {
          return (
            <div className="product-card" key={collection.id}>
              <div className="img-wrapper">
                <Link
                  to={{
                    pathname: `product-page/${collection.id}`,
                    query: { id: collection.id }
                  }}
                >
                  
                  <SimpleImg height={125} src={collection.img} alt={ collection.alt } placeholder="#ffffff" />
                </Link>
              </div>
              <h5>
                <Link
                  to={{
                    pathname: `product-page/${collection.id}`,
                    query: { id: collection.id }
                  }}
                >
                  {collection.alt}
                </Link>
              </h5>
              <div className="price-section">
                <div className="price-section__price">$ {collection.price}</div>
                <AddButton pd={collection} className="round" btnText="+" />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
